// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9b97b5a7","513":"6b5bf0a8","703":"2fcd7bce"}[chunkId] + ".chunk.js";
};